import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ScrollToTop } from './components/ScrollToTop';
import './styles.css';
// Gespeichertes Thema vor dem ersten Rendern anwenden – nicht erst, wenn die Einstellungen geladen sind.
import './pages/einstellungen/theme';
// „Als App installieren" meldet Chrome nur einmal beim Laden.
import './lib/install';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </StrictMode>,
);
